import WorkspaceGeneralForm from '../pages/workspace-general-form.vue'
import WorkspaceInvestorSettingsForm from '../pages/workspace-investor-settings-form.vue'
import WorkspaceCompanySettingsForm from '../pages/workspace-company-settings-form.vue'
import WorkspaceRemindersForm from '../pages/workspace-reminders-form.vue'
import WorkspaceEmailForm from '../pages/workspace-email-form.vue'
import WorkspaceDeleteForm from '../pages/workspace-delete-form.vue'
import WorkspaceOnboardingPage from '../pages/workspace-onboarding-page.vue'

export default [
  {
    component: WorkspaceOnboardingPage,
    name: 'workspace.onboarding',
    path: '/:slug/workspace/onboarding',
  },
  {
    component: WorkspaceGeneralForm,
    name: 'workspace.settings',
    path: '/:slug/workspace/settings',
  },
  {
    component: WorkspaceInvestorSettingsForm,
    name: 'workspace.settings.investor',
    path: '/:slug/workspace/settings/investor',
  },
  {
    component: WorkspaceCompanySettingsForm,
    name: 'workspace.settings.company',
    path: '/:slug/workspace/settings/company',
  },
  {
    component: WorkspaceRemindersForm,
    name: 'workspace.settings.reminders',
    path: '/:slug/workspace/settings/reminders',
  },
  {
    component: WorkspaceEmailForm,
    name: 'workspace.settings.emails',
    path: '/:slug/workspace/settings/emails',
  },
  {
    component: WorkspaceDeleteForm,
    name: 'workspace.settings.delete',
    path: '/:slug/workspace/settings/delete',
  },
]
